import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { MeState } from './meSlice';

export const useMeStateSelector: TypedUseSelectorHook<{ me: MeState }> = useSelector;
